var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"appmenu flex gap-5",attrs:{"aria-label":_vm.$t('mainNav')}},_vm._l((_vm.navigation),function(item,index){return _c('router-link',{key:`am_${index}`,attrs:{"to":{ name: item.route }}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }